import { render, staticRenderFns } from "./VideoModal.vue?vue&type=template&id=6ac783a2&scoped=true&lang=pug"
import script from "./VideoModal.vue?vue&type=script&lang=js"
export * from "./VideoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac783a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac783a2')) {
      api.createRecord('6ac783a2', component.options)
    } else {
      api.reload('6ac783a2', component.options)
    }
    module.hot.accept("./VideoModal.vue?vue&type=template&id=6ac783a2&scoped=true&lang=pug", function () {
      api.rerender('6ac783a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/video/VideoModal.vue"
export default component.exports